import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const PUBLISH_OFFER_START = 'PUBLISH_OFFER :: START';

export type TPublishOfferStartAction = IReduxAction<typeof PUBLISH_OFFER_START>;

export const publishOfferStart = actionGenerator<typeof PUBLISH_OFFER_START>(PUBLISH_OFFER_START);
